"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateKicadV6SchemaFile = validateKicadV6SchemaFile;
const NodeParser_1 = require("../../common/NodeParser");
const Util_1 = require("../../Util");
const constants_1 = require("../constants");
const v6ExtractSheetInfo_1 = require("./v6ExtractSheetInfo");
const v6ParseTitleBlock_1 = require("./v6ParseTitleBlock");
function validateKicadV6SchemaFile(fileContents, parseSheets, allowMissingVersion) {
    let version;
    let referencedFiles = [];
    const metadata = {};
    const tree = NodeParser_1.SExpressionFileParser.Parse(fileContents);
    tree.nodes.forEach((node) => {
        switch (node.name) {
            case 'version': {
                version = (0, Util_1.removeQuotes)(node.values[0]);
                break;
            }
            case 'title_block': {
                const titleBlock = (0, v6ParseTitleBlock_1.extractTitleBlock)(node);
                for (const [key, value] of Object.entries(titleBlock)) {
                    if (typeof value !== 'string') {
                        continue;
                    }
                    metadata[`kicad${key}`] = value;
                }
                break;
            }
            case 'sheet': {
                if (!parseSheets) {
                    break;
                }
                const sheet = (0, v6ExtractSheetInfo_1.extractSheetInfo)(node);
                if (sheet.sheetfile) {
                    if (!referencedFiles) {
                        referencedFiles = [];
                    }
                    if (referencedFiles.indexOf(sheet.sheetfile) === -1) {
                        referencedFiles.push(sheet.sheetfile);
                    }
                }
                break;
            }
            case 'sheet_instances': {
                if (!parseSheets) {
                    break;
                }
                const pathNode = node.nodes.find((n) => n.name === 'path');
                if (pathNode?.values[0] === '"/"') {
                    const pageNode = pathNode.nodes.find((n) => n.name === 'page');
                    {
                        if (pageNode?.values[0] === '"1"') {
                            metadata[constants_1.MetadataKicadIsRoot] = String(true);
                        }
                    }
                }
                break;
            }
        }
    });
    if (!version && !allowMissingVersion) {
        throw new Error('Kicad file missing version information');
    }
    return {
        version,
        referencedFiles,
        metadata,
    };
}
//# sourceMappingURL=validateKicadV6SchemaFile.js.map